
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetonagpurcab() {



    const cardData =
    {
        keyword: 'Pune To Nagpur Cab',
        heading: 'Mauli Cabs: Pune To Nagpur Cab',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Nagpur cab services, ensuring a smooth and efficient journey to the Orange City of India. Whether you are traveling for business, leisure, or to explore the local attractions, we provide a variety of vehicles including sedans, SUVs, and premium cars to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free and enjoyable ride from Pune to Nagpur.',

        top: 'Top Places to Visit in Nagpur with Mauli Cabs',

"topPlaces": [
    {
        "title": "Saputara Lake",
        "description": "A serene man-made lake surrounded by lush greenery, offering pedal boating and picnic spots. It's a central attraction in Saputara, ideal for relaxation and family outings.",
        "image": "https://example.com/saputara-lake.jpg"
    },
    {
        "title": "Sunset Point",
        "description": "Situated on Sunset Point Road, this viewpoint offers breathtaking views of the sun setting over the Sahyadri hills, making it a popular spot for evening visits.",
        "image": "https://example.com/sunset-point.jpg"
    },
    {
        "title": "Sunrise Point",
        "description": "Located at the top of a hill, Sunrise Point provides a panoramic view of the sunrise over the town and surrounding valleys, accessible via a short trek.",
        "image": "https://example.com/sunrise-point.jpg"
    },
    {
        "title": "Gira Waterfalls",
        "description": "A picturesque waterfall located about 5 km from Saputara, Gira Falls is a popular monsoon destination, offering a refreshing experience amidst nature.",
        "image": "https://example.com/gira-waterfalls.jpg"
    },
    {
        "title": "Hatgadh Fort",
        "description": "A historic fort located approximately 6 km from Saputara, Hatgadh Fort offers panoramic views and a glimpse into the region's history.",
        "image": "https://example.com/hatgadh-fort.jpg"
    },
    {
        "title": "Saputara Ropeway (Pushpak Ropeway)",
        "description": "This ropeway connects Sunset Point to Sunrise Point, offering aerial views of the town and surrounding landscapes, enhancing the sightseeing experience.",
        "image": "https://example.com/saputara-ropeway.jpg"
    },
    {
        "title": "Pandava Gufa",
        "description": "A series of caves believed to have been used by the Pandavas during their exile, located amidst dense forests, offering a blend of adventure and mythology.",
        "image": "https://example.com/pandava-gufa.jpg"
    },
    {
        "title": "Tribal Museum",
        "description": "Located near Saputara Lake, the Tribal Museum showcases artifacts and exhibits related to the indigenous tribes of the Dangs region, providing cultural insights.",
        "image": "https://example.com/tribal-museum.jpg"
    },
    {
        "title": "Step Garden",
        "description": "A beautifully landscaped garden featuring terraced steps adorned with various plants and flowers, offering a peaceful environment for visitors.",
        "image": "https://example.com/step-garden.jpg"
    },
    {
        "title": "Vansda National Park",
        "description": "Located about 25 km from Saputara, Vansda National Park is a tropical rainforest sanctuary, home to diverse flora and fauna, ideal for nature enthusiasts.",
        "image": "https://example.com/vansda-national-park.jpg"
    }
],

"services": [
    {
        "name": "Pune to Nagpur Cab Service",
        "description": "Looking for a reliable cab service from Pune to Nagpur? Enjoy a smooth, comfortable, and hassle-free journey with Mauli Cabs. Book your ride today!"
    },
    {
        "name": "Book Pune to Nagpur Taxi",
        "description": "Book your Pune to Nagpur taxi with Mauli Cabs. We provide easy and convenient online booking for a seamless travel experience."
    },
    {
        "name": "Affordable Pune to Nagpur Cab",
        "description": "Mauli Cabs offers affordable taxi services for your Pune to Nagpur trip, ensuring value for money without compromising comfort and reliability."
    },
    {
        "name": "Private Taxi for Nagpur from Pune",
        "description": "Travel privately from Pune to Nagpur with Mauli Cabs. We offer dedicated, private taxis for a personalized, stress-free journey."
    },
    {
        "name": "Nagpur Trip by Cab from Pune",
        "description": "Planning a trip to Nagpur? Travel conveniently with Mauli Cabs for a smooth, safe, and enjoyable ride from Pune to Nagpur."
    },
    {
        "name": "Pune to Nagpur One-Way or Round Trip",
        "description": "Choose the best option for your journey! Mauli Cabs offers one-way and round-trip services for your Pune to Nagpur travel plans."
    },
    {
        "name": "Comfortable Taxi Ride to Nagpur",
        "description": "Experience a comfortable and relaxing ride from Pune to Nagpur with Mauli Cabs. Our well-maintained vehicles ensure a pleasant journey."
    },
    {
        "name": "Group Travel to Nagpur",
        "description": "Traveling with a group? Mauli Cabs offers spacious vehicles for group trips from Pune to Nagpur. Enjoy your journey together in comfort."
    },
    {
        "name": "Luxury Taxi for Nagpur Trip",
        "description": "For a more luxurious experience, choose Mauli Cabs' luxury taxi services for your Pune to Nagpur trip. Enjoy top-tier comfort and style."
    },
    {
        "name": "Nagpur Sightseeing by Taxi",
        "description": "Explore Nagpur's top attractions with Mauli Cabs' sightseeing tours. Sit back and relax as we take you to the best landmarks and tourist spots in Nagpur."
    }
],

"tableData": [
    ["Pune to Nagpur Cab Service", "Book Pune to Nagpur Taxi"],
    ["Affordable Pune to Nagpur Cab", "Private Taxi for Nagpur from Pune"],
    ["Nagpur Trip by Cab from Pune", "Pune to Nagpur One-Way or Round Trip"],
    ["Comfortable Taxi Ride to Nagpur", "Group Travel to Nagpur"],
    ["Luxury Taxi for Nagpur Trip", "Nagpur Sightseeing by Taxi"]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs ensures reliable and timely service for your Pune to Nagpur Cab journey. Our professional drivers are committed to providing prompt pickups and drop-offs, ensuring you reach Nagpur on time, whether for business or leisure."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Nagpur trip, we offer a range of comfortable vehicles, including sedans, SUVs, and premium cars. All vehicles are air-conditioned, spacious, and well-maintained, ensuring a comfortable ride throughout the long journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions for the Pune to Nagpur trip. They ensure a smooth, safe, and efficient journey, so you can relax and enjoy your travel experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive and transparent pricing for your Pune to Nagpur Cab booking. With no hidden charges, you can rest assured that you are getting the best value for your money during your journey."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and pleasant journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Nagpur journey. Whether you need an early morning ride or a late-night return, our customer service team is always ready to assist you with your booking at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Nagpur cab with Mauli Cabs is easy and convenient. You can book your ride online via our website or mobile app, or contact our customer service team for personalized assistance to ensure a smooth booking process."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Nagpur trip. Whether you're traveling for business, a family trip, or a solo adventure, we can tailor the trip to suit your specific needs and preferences."
    }
]























    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Nagpur with Mauli Cabs?',
            answer: 'Booking your cab for a trip from Pune to Nagpur is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Nagpur as your destination, then choose the vehicle that suits your needs. Alternatively, you can call our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Nagpur trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your trip to Nagpur, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can select a vehicle based on your group size, comfort preferences, and budget.',
        },
        {
            question: 'Is the fare for the Pune to Nagpur trip fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges, with no hidden costs. The total fare is provided upfront before confirming your booking.',
        },
        {
            question: 'How long does the journey from Pune to Nagpur take?',
            answer: 'The journey from Pune to Nagpur typically takes around 8 to 9 hours, depending on traffic conditions. Our drivers ensure a smooth and safe journey, with comfortable stops along the way for your convenience.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Nagpur route?',
            answer: 'Yes, Mauli Cabs drivers are experienced with the Pune to Nagpur route and are familiar with the best roads to ensure a safe and timely journey. They prioritize your comfort and safety throughout the trip.',
        },
        {
            question: 'Can I book a round trip for the Pune to Nagpur trip?',
            answer: 'Yes, you can easily book a round trip to Nagpur. Just provide your return details when making the booking, and we will ensure a smooth return journey back to Pune.',
        },
        {
            question: 'Can I make stops for sightseeing along the way to Nagpur?',
            answer: 'Yes, you can customize your trip by making stops for sightseeing or taking breaks along the way. Whether you want to visit popular spots or simply rest during the journey, our drivers will be happy to accommodate your requests.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for cleanliness and comfort. We prioritize your comfort and ensure a pleasant ride during your journey to Nagpur.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy through our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Nagpur trip?',
            answer: 'Mauli Cabs offers reliable service, competitive pricing, a wide range of vehicle options, and experienced drivers. We ensure that your trip to Nagpur is smooth, comfortable, and enjoyable.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Amit Kumar",
            position: "Business Traveler",
            text: "My journey from Pune to Nagpur with Mauli Cabs was incredibly smooth and comfortable. The driver was professional, the car was in excellent condition, and we had timely stops along the way. I would recommend Mauli Cabs to anyone traveling between Pune and Nagpur.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Priya Desai",
            position: "Leisure Traveler",
            text: "I had a wonderful experience traveling from Pune to Nagpur with Mauli Cabs. The vehicle was clean, spacious, and well-maintained, and the driver was friendly and experienced. The journey was comfortable, and I felt safe the entire time. Highly recommend!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Nagpur Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Nagpur. Choose from private, luxury, or group taxis for a one-way or round-trip journey. Enjoy a smooth and reliable ride to Nagpur with 24x7 online booking support, ideal for sightseeing and exploring the city.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
     

    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Nagpur Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Nagpur cab with Mauli Cabs. Choose from affordable, private, luxury, and group taxi options for one-way or round-trip travel. Enjoy a comfortable and reliable ride with 24x7 online booking, perfect for sightseeing in Nagpur."
        />
        <meta
          name="keywords"
          content="Pune to Nagpur cab service, Book Pune to Nagpur taxi, Affordable Pune to Nagpur cab, Private taxi for Nagpur from Pune, Nagpur trip by cab from Pune, Pune to Nagpur one-way or round trip, Comfortable taxi ride to Nagpur, Group travel to Nagpur, Luxury taxi for Nagpur trip, Nagpur sightseeing by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/29.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetonagpurcab;